// extracted by mini-css-extract-plugin
export default {"walkIns":"clinicWalkins_walkIns__t1e3g"};